export const en = {
  translation: {
    Table: {
      All: 'All',
      ID: 'ID',
      User: 'User',
      'Order ID': 'Order ID',
      'Start count': 'Start count',
      Quantity: 'Quantity',
      'Current count': 'Current count',
      'To refill': 'To refill',
      Service: 'Service',
      Status: 'Status',
      Created: 'Created',
      Mode: 'Mode',
      'Fraud risk': 'Fraud risk',
      Method: 'Method',
      Empty: '',
      Actions: 'Actions',
      MassCounterTickets: '{{count}} tickets selected',
      MassCounterUsers: '{{count}} users selected',
      MassCounterUserRate: '{{count}} services selected',
      MassCounterRefill: '{{count}} tasks selected',
      MassCounterOrders: '{{count}} orders selected',
      MassCounterUpdates: '{{count}} updates selected',
      MassCounterDripFeed: '{{count}} drip-feeds selected',
      Fail: 'Fail',
    },
    Navbar: {
      Users: 'Users',
      Orders: 'Orders',
      Subscriptions: 'Subscriptions',
      'Drip-feed': 'Drip-feed',
      Tasks: 'Tasks',
      Refill: 'Refill',
      Cancel: 'Cancel',
      Services: 'Services',
      Payments: 'Payments',
      Tickets: 'Tickets',
      Affiliates: 'Affiliates',
      Updates: 'Updates',
      'Child panels': 'Child panels',
      Reports: 'Reports',
      Appearance: 'Appearance',
      Settings: 'Settings',
      Account: 'Account',
      Logout: 'Logout',
    },
    ActionsList: {
      Answered: 'Answered',
      Closed: 'Closed',
      Pending: 'Pending',
      'Error details': 'Error details',
      'Fail details': 'Fail details',
      'Order details': 'Order details',
      'Change status': 'Change status',
      Resend: 'Resend',
      'Resend order': 'Resend order',
      'Edit link': 'Edit link',
      'Set start count': 'Set start count',
      'Set partial': 'Set partial',
      'Set remains': 'Set remains',
      'Update remains': 'Update remains',
      Cancel: 'Cancel',
      'Request cancel': 'Request cancel',
      'Cancel and refund': 'Cancel and refund',
      'In progress': 'In progress',
      Rejected: 'Rejected',
      Details: 'Details',
      'Cancel reason': 'Cancel reason',
      Refill: 'Request refill',
      'Disable refill': 'Disable refill',
      'Details for superadmin': 'Details for superadmin',
      Processing: 'Processing',
      Success: 'Success',
      Complete: 'Complete',
      Completed: 'Completed',
      'Edit rates': 'Edit rates',
      'Delete rates': 'Delete rates',
      'Copy to clipboard': 'Copy to clipboard',
      'Update from provider': 'Update from provider',
    },
    Tabs: {
      All: 'All',
      'All orders': 'All orders',
      Awaiting: 'Awaiting',
      Pending: 'Pending',
      'In progress': 'In progress',
      Rejected: 'Rejected',
      Error: 'Error',
      Completed: 'Completed',
      Processing: 'Processing',
      Success: 'Success',
      Canceled: 'Canceled',
      Partial: 'Partial',
      Expired: 'Expired',
      Active: 'Active',
      Paused: 'Paused',
      Fail: 'Fail',
      Frozen: 'Frozen',
      Terminated: 'Terminated',
      Suspended: 'Suspended',
    },
    SearchGroup: {
      Placeholder: {
        Search: 'Search',
        'Search users': 'Search users',
        'Search tickets': 'Search tickets',
        'Search orders': 'Search orders',
        'Search tasks': 'Search tasks',
        'Search child panels': 'Search child panels',
      },
    },
  },
};
